import { StandardEvents } from '@shopify/events';

// Replaces this element's content with the matching element from the page HTML
// the variant picker fetches for the newly selected variant.
class VariantField extends HTMLElement {
  #target = null;

  connectedCallback() {
    this.#target = this.closest('[id*="ProductInformation-"]');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  #onSelect = (event) => {
    event.promise
      .then(({ detail }) => {
        const fresh = detail?.html?.querySelector(`[data-variant-field="${this.dataset.variantField}"]`);
        if (fresh) this.innerHTML = fresh.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[variant-field]', error);
      });
  };
}

if (!customElements.get('variant-field')) customElements.define('variant-field', VariantField);
